export default class IngredientsTimeline {
    constructor(el) {
        this.el = el;
        this.items = Array.from(this.el.querySelectorAll('.js-ingredients-timeline-item'));
        this.header = document.querySelector('.section-header');
        this.scrollTicking = false;
        this.activeDot = null;

        if (!this.items.length) return;

        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.onScroll();

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.items.forEach(item => item.classList.add('is-active'));
        } else if (!('IntersectionObserver' in window)) {
            this.items.forEach(item => item.classList.add('is-active'));
        } else {
            this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
                root: null,
                threshold: 0.25,
                rootMargin: '0px 0px -10% 0px'
            });

            this.items.forEach(item => this.observer.observe(item));
        }
    }

    onIntersect(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-active');
            }
        });
    }

    onScroll() {
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        window.requestAnimationFrame(() => {
            this.updateActiveDots();
            this.scrollTicking = false;
        });
    }

    updateActiveDots() {
        const markerY = window.innerHeight / 2;
        let closestDot = null;
        let closestDistance = Number.POSITIVE_INFINITY;

        this.items.forEach(item => {
            const dot = item.querySelector('.js-ingredients-timeline-dot');
            if (!dot) return;

            const dotRect = dot.getBoundingClientRect();
            const dotCenter = dotRect.top + dotRect.height / 2;
            const distance = Math.abs(dotCenter - markerY);

            if (distance < closestDistance) {
                closestDistance = distance;
                closestDot = dot;
            }
        });

        this.items.forEach(item => {
            const dot = item.querySelector('.js-ingredients-timeline-dot');
            if (!dot) return;
            if (dot === closestDot) {
                dot.classList.add('is-active');
            } else {
                dot.classList.remove('is-active');
            }
        });

        if (closestDot && closestDot !== this.activeDot) {
            this.activeDot = closestDot;
            this.activeDot.classList.remove('is-pulsing');
            // Force reflow so the animation can retrigger reliably
            void this.activeDot.offsetWidth;
            this.activeDot.classList.add('is-pulsing');
            const onPulseEnd = () => {
                this.activeDot?.classList.remove('is-pulsing');
                this.activeDot?.removeEventListener('animationend', onPulseEnd);
            };
            this.activeDot.addEventListener('animationend', onPulseEnd);
        }
    }
}
